import {useState, useEffect} from "react";
import SelectableContainer from "./SelectableContainer";
import { Col, Row } from "./Flexbox";
import Text from "./Text";

const SelectMonthContainer = props => {

    const [months, setMonths] = useState({});
    const [activeMonths, setActiveMonths] = useState([]);

    const hoverSingle = month => { //Hovers individual months
        setActiveMonths([month]);
    }

    const handleHoverOut = () => {
        setActiveMonths([]);
    }

   const editMonthsList = month => {
        const monthToUpdate = month;

        const currentMonths = props.selectedMonths ?? [];
        const index = currentMonths.indexOf(monthToUpdate);
        let updatedMonths = [...currentMonths];

        if (index === -1) {
            updatedMonths.push(monthToUpdate);
        } else {
            updatedMonths.splice(index, 1);
        }

        props.updateMonths(updatedMonths);
    };

    useEffect(() => {
        const monthsByYear = {};

        if(props.detectedMonths && props.detectedMonths.length > 0) {
            props.detectedMonths.forEach(detectedMonth => {
                const [month, year] = detectedMonth.split(' '); //Split the month from the year 

                if(!monthsByYear[year]) {   //Creates an array for each year
                    monthsByYear[year] = [];
                }
                monthsByYear[year].push(`${month} ${year}`); //Add the months according to the year
            });

            setMonths(monthsByYear);
        } else {
            setMonths({});
        }
    }, [props.detectedMonths]);

    const formatMonths = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return (
        <Col style={{flex:'none', width:'100%', ...props.style}}>
            {props.showYear && Object.entries(months).map(([year, months]) => ( //Include the year and show the months according to it
                <Col key={year} style={{ width:'100%', alignItems:'flex-start',}}>
                    <Text color={props.theme.THREEB} size={12}>{year}</Text>
                    <Row style={{flexWrap:'wrap', justifyContent:'flex-start', width:'100%', flex:'none', marginTop: 8}}>
                        {months.map((fullMonth) => {
                            const currentMonths = props.selectedMonths ?? [];
                            const isActive = currentMonths.includes(fullMonth) || activeMonths.includes(fullMonth); //Active if it's in the selected months, or if it's being hovered
                            const [month] = fullMonth.split(' ');
                            return (
                                <SelectableContainer onHoverOut={handleHoverOut} onHover={hoverSingle} key={fullMonth} active={isActive} theme={props.theme} onClick={() => editMonthsList(fullMonth)} text={formatMonths(month)}/>
                            )
                        })}
                    </Row>
                </Col>
            ))}

            {!props.showYear && (   //Skip the year and show all months in a row
                <Row style={{flexWrap: props.style?.flexWrap || 'wrap', justifyContent:'flex-start', width:'100%', flex:'none', marginTop: 8}}>
                    {Object.entries(months).map(([year, yearMonths]) => (
                        <Col key={year} style={{width: props.style?.flexWrap === 'nowrap' ? 'auto' : '100%', alignItems:'start', gap: '8px'}}>
                            <Text color={props.theme.Audi} size={11}>{year}</Text>
                            <Row style={{justifyContent:'flex-start', width:'100%', flexWrap: props.style?.flexWrap || 'wrap'}}>
                                {yearMonths.map((fullMonth) => {
                                    const currentMonths = props.selectedMonths ?? [];
                                    const [monthName] = fullMonth.split(' ');
                                    const isActive = currentMonths.includes(fullMonth) || activeMonths.includes(fullMonth); //Active if it's in the selected months, or if it's being hovered
                                    return (
                                        <SelectableContainer onHoverOut={handleHoverOut} onHover={hoverSingle} key={fullMonth} active={isActive} theme={props.theme} onClick={() => editMonthsList(fullMonth)} text={formatMonths(monthName)}/>
                                    )
                                })}
                            </Row>
                        </Col>
                    ))}
                </Row>
            )}
        </Col>
    )   
}

export default SelectMonthContainer;